<template>
	<div v-if="pagination && pagination.total" class="pager">
		<div class="pager-left">
			<span class="muted">Showing {{ pagination.from }}–{{ pagination.to }} of {{ Number(pagination.total).toLocaleString() }}</span>
			<label class="rows-per">Rows
				<select :value="perPage" @change="$emit('input', Number($event.target.value))">
					<option v-for="n in [10, 30, 100]" :key="n" :value="n">{{ n }}</option>
				</select>
			</label>
		</div>
		<div class="pager-nav"><button class="pgbtn" :disabled="pagination.current_page <= 1" @click="$emit('go', pagination.current_page - 1)"><i class="fa-solid fa-chevron-left"></i> Prev</button><span class="pgnum">Page {{ pagination.current_page }} of {{ pagination.last_page }}</span><button class="pgbtn" :disabled="pagination.current_page >= pagination.last_page" @click="$emit('go', pagination.current_page + 1)">Next <i class="fa-solid fa-chevron-right"></i></button></div>
	</div>
</template>

<script>
export default {
	name: 'PePager',
	props: {
		pagination: { type: Object, default: null }, // { from, to, total, current_page, last_page }
		perPage: { type: Number, default: 30 },
	},
}
</script>
